function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_12709",
  "data-name": "Group 12709"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13964",
  "data-name": "Path 13964",
  d: "M52,14.164a2.176,2.176,0,0,0-1.59-.489,2.111,2.111,0,0,0-1.468.758l-5.823,7a3.251,3.251,0,0,0-.758,2.422,1.565,1.565,0,0,0,.563,1.1,1.678,1.678,0,0,0,1.1.391h.2a3.367,3.367,0,0,0,2.251-1.15l5.8-6.972A2.193,2.193,0,0,0,52,14.164Zm-6.508,9.223a2.108,2.108,0,0,1-1.468.709c-.2,0-.342-.122-.367-.391a1.889,1.889,0,0,1,.465-1.419l3.963-4.746a.151.151,0,0,1,.171-.024l1.174.979a.151.151,0,0,1,.024.171Zm5.8-6.972-.881,1.076a.151.151,0,0,1-.171.024l-1.174-.979a.151.151,0,0,1-.024-.171l.881-1.076a.936.936,0,0,1,.612-.318h.073a.924.924,0,0,1,.563.2h0a.936.936,0,0,1,.318.612A.9.9,0,0,1,51.293,16.415Z",
  transform: "translate(-35.66 -13.667)",
  fill: "#0ca14a"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_12708",
  "data-name": "Group 12708",
  transform: "translate(0 2.479)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13965",
  "data-name": "Path 13965",
  d: "M27.085,39.115H18.229A3.226,3.226,0,0,1,15,35.885V27.029A3.226,3.226,0,0,1,18.229,23.8H23a.606.606,0,0,1,.612.612h0a.684.684,0,0,1-.685.685h-4.7A1.921,1.921,0,0,0,16.3,27.029v8.856a1.921,1.921,0,0,0,1.933,1.933h8.856a1.921,1.921,0,0,0,1.933-1.933V31.311a.606.606,0,0,1,.612-.612H29.7a.606.606,0,0,1,.612.612v4.6A3.221,3.221,0,0,1,27.085,39.115Z",
  transform: "translate(-15 -23.8)",
  fill: "#0ca14a"
})));
const SvgEditIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12712",
    "data-name": "Group 12712",
    width: 17.116,
    height: 17.794,
    viewBox: "0 0 17.116 17.794",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EditIcon.7180d660.svg";
export { ForwardRef as ReactComponent };